import React, { useState } from "react";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";

const ReactTable = ({
  columns,
  defaultData,
  borderB = true,
  lineHeight = false,
}) => {
  const [data, setData] = React.useState(() => [...defaultData]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      <div className="font-poppins">
        {/* Mobile View */}
        <div className="block md:hidden">
          {table.getRowModel().rows.map((row) => (
            <div
              key={row.id}
              className="border border-gray-300 rounded-lg p-4 mb-4 bg-white shadow-sm"
            >
              {row.getVisibleCells().map((cell, index) => (
                <div
                  key={cell.id}
                  className="flex justify-between items-center mb-2"
                >
                  <span className="font-semibold text-sm text-gray-700">
                    {flexRender(
                      cell.column.columnDef.header,
                      cell.getContext()
                    )}
                  </span>
                  <span className="text-sm text-gray-600">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block overflow-x-auto">
          <table className="min-w-full table-auto border-collapse">
            <thead className="bg-[#E7F0FF]">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="text-left">
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      className={`py-4 px-3 text-[#035C98] text-[16px] font-semibold bg-white ${
                        index === 0 ? "rounded-l-lg" : ""
                      } ${
                        index === headerGroup.headers.length - 1
                          ? "rounded-r-lg"
                          : ""
                      }`}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b border-gray-200 hover:bg-gray-50 "
                >
                  {row.getVisibleCells().map((cell, index) => (
                    <td
                      key={cell.id}
                      className={`py-3 px-4 text-sm text-gray-700 ${
                        index === 0 ? "whitespace-nowrap" : "whitespace-normal"
                      }`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            {table.getFooterGroups().length > 0 && (
              <tfoot>
                {table.getFooterGroups().map((footerGroup) => (
                  <tr key={footerGroup.id}>
                    {footerGroup.headers.map((header) => (
                      <th
                        key={header.id}
                        className="py-2 px-3 text-sm text-gray-500"
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.footer,
                              header.getContext()
                            )}
                      </th>
                    ))}
                  </tr>
                ))}
              </tfoot>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default ReactTable;
